import { schema } from 'normalizr';

export const environmentSchema = new schema.Entity('environments', {}, { idAttribute: '_id' });

export const projectSchema = new schema.Entity(
  'projects',
  {
    environments: [environmentSchema],
  },
  {
    idAttribute: 'key',
  },
);
